export interface SiteCoreDictionary {
    [value: string]: string;
}

interface PiwikTag {
    dataTrackId: string;
    dataTrackLinkname: string;
}

interface PiwikTags {
    [value: string]: PiwikTag;
}

export interface Piwik {
    [value: string]: PiwikTags;
}

export enum BlockType {
    SOFT_BLOCK = 'SOFT_BLOCK',
    HARD_BLOCK = 'HARD_BLOCK',
    TERMINATE_ACCOUNT = 'TERMINATE_ACCOUNT',
}
